import React from 'react';
import 'index.css';
import './MiniMap.scss';
import Leaflet from "leaflet";
import { Map, TileLayer, Marker, Circle, Tooltip } from 'react-leaflet';

const greyIcon = new Leaflet.Icon({
  iconUrl: 'https://cdn.rawgit.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-grey.png',
  shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png',
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41]
});
const redIcon = new Leaflet.Icon({
  iconUrl: 'https://cdn.rawgit.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-red.png',
  shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png',
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41]
});


const MiniMap = ({
    lat,
    lng,
    zoom,
    radius,
    cinemas,
}) => {
    const latitude = parseFloat(lat);
    const longitude = parseFloat(lng);
    return (
        <Map center={[latitude, longitude]} zoom={zoom} zoomControl={true} >
            <TileLayer
                attribution='<a href="http://osm.org/copyright">OpenStreetMap</a>'
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            />
            <Circle center={[latitude, longitude]} color="#3f51b5" radius={radius} />
            <Marker position={[latitude, longitude]} />
            {cinemas.map((c) => (
                <Marker
                    key={c.cinema_id}
                    position={[c.latitude, c.longitude]}
                    icon={(c.distance <= c.radius && c.isInSameCountry) ? redIcon : greyIcon}
                >
                    <Tooltip>{c.cinema_name} / {c.city_name}</Tooltip>
                </Marker>
            ))}
        </Map>
    );
};

export default MiniMap;
